/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ScoreByAnswerToOtherQuestionBarChart_answersReport = {|
  +scoreByAnswerToOtherQuestion: ?$ReadOnlyArray<?{|
    +text: ?$ReadOnlyArray<?{|
      +language: ?string;
      +text: ?string;
    |}>;
    +score: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "otherQuestionMongoId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScoreByAnswerToOtherQuestionBarChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "otherQuestionMongoId",
          "variableName": "otherQuestionMongoId",
          "type": "ID"
        }
      ],
      "concreteType": "ScoreByAnswerToOtherQuestion",
      "name": "scoreByAnswerToOtherQuestion",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Translation",
          "name": "text",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "language",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "score",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/ScoreByAnswerToOtherQuestionBarChart/__generated__/ScoreByAnswerToOtherQuestionBarChart_answersReport.graphql.js